import React from "react";
import {NavLink} from "react-router-dom";

const About = () => {
    return (
        <>
            <div className={"about-container"}>
                <nav>
                    <ul>
                        <li><NavLink to='/'>ARTWORKS</NavLink></li>
                        <li><NavLink to='/designs'>DESIGNS</NavLink></li>
                        <li><NavLink style={{color: '#fee4ee'}} to='/about'>ABOUT</NavLink></li>
                    </ul>
                </nav>

                <div className={'about'}>
                    <h3 style={{marginLeft: "0.938rem", marginTop: "1em", color: "#635f5a", fontWeight: "300", fontSize: "2.5rem"}}>About Me</h3>
                    <img className="profile" src={require('../pfp/new-me.png')} width={150} height={150} alt='Alivia Guo' />
                    <div className={"about-div"}>
                        <div className={"about-content"}>
                            <p>Hello! I’m Alivia Guo, your art buddy! I like drawing and will be sharing my artworks on here. Thank you for stopping by!</p>
                            <p>こんにちは、アリヴィア・グオです！2019年から日本語を勉強し始めて、今も続いています。<span className={"nowrap"}>(灬╹ω╹灬)</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default About;
